import React from 'react';
import ReactDOM from 'react-dom';
import App from "./js/components/App";
import {Provider} from 'react-redux';
import {loadTranslations, setLocale, syncTranslationWithStore} from 'react-redux-i18n';
import store from './js/store';
import en from './js/translations/en';
import * as serviceWorker from './serviceWorker';
import './assets/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import './assets/css/Main.css';

const translationsObject = {
    en: en
}

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translationsObject));
store.dispatch(setLocale('en'));

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>
    ,document.getElementById("main-app"));


serviceWorker.unregister();
